import React, { useState, useEffect, useMemo } from 'react'
import { Row, Col, Button, ButtonGroup, Alert } from 'react-bootstrap'
import { Segment, Icon, Dimmer, Image, Loader, Header } from 'semantic-ui-react'
import { Amplify, API, Auth } from 'aws-amplify';
import NavBar from './NavBar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import { useHistory, Link } from "react-router-dom";
import { Tooltip } from 'antd';

function simulateNetworkRequest() {
    return new Promise((resolve) => setTimeout(resolve, 2000));
}

export default function Results() {

    const [username, setUsername] = useState();

    const [params, setParams] = useState([]);

    const [id_import, setId_import] = useState();

    const [items, setItems] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    const [result, setResult] = useState([]);
    const [error, setError] = useState();
    const [mark, setMark] = useState(0);

    let history = useHistory();

    const Bucket = "https:///alphafold2-prod.s3.amazonaws.com/";

    const [clicked, setClicked] = useState(false);

    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    
    function getUserInfo() {
		Auth.currentAuthenticatedUser({
			bypassCache: false
		}).then(
			user => {
				console.log(user)
				setUsername(user.attributes.email);
			}
		)
			.catch(err => console.log(err));
	}

	useEffect(() => {
		getUserInfo();
	}, [])

    useEffect(() => {
      if(username !== undefined){
        console.log(username);
        requestData()
      }
    }, [username])
    

    useEffect(() => {
        if (clicked) {
            simulateNetworkRequest().then(() => {
                setClicked(false);
            });
        }
    }, [clicked]);

    async function requestData() {
        Amplify.Logger.LOG_LEVEL = "DEBUG";

        // const session = await Auth.currentCredentials();
        const session = await Auth.currentSession();
        // console.log(session)
        const apiRequest = {
            // body: {
            //     "Username": username,

            // },
            headers: {
                "Content-Type": "application/json",
                "Authorization":  session.getIdToken().getJwtToken()

            },
        };

        return await API
            .get("AlphaFold2", "/result", apiRequest)
            .then(
                (data) => {
                    console.log(data);
                    setItems(data.Items);
                    setTimeout(() => {
                        setIsLoaded(true);
                    }, 500);
                },
                (error) => {
                    console.log(error);
                }
            );
    };

    function handleRefresh() {
        window.location = "/results";
    }


    function handleJump(e) {
        let current = e.target.value;
        // console.log(current);
        history.push({ pathname: '/detail', state: { id: current } });
    }

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = useState(config);

        const sortedItems = useMemo(() => {
            let sortableItems = [...items];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === "ascending" ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === "ascending" ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfig]);

        const requestSort = key => {
            let direction = "descending";
            if (
                sortConfig &&
                sortConfig.key === key &&
                sortConfig.direction === "descending"
            ) {
                direction = "ascending";
            }
            setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };

    function ProjectTable(props) {
        const { items, requestSort, sortConfig } = useSortableData(props.projects);

        setMark(1);
        useEffect(() => {
            requestSort("Timestamp");
        }, [mark]);
        const getClassNamesFor = name => {
            if (!sortConfig) {
                return;
            }
            return sortConfig.key === name ? sortConfig.direction : undefined;
        };

        return (
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                onClick={() => requestSort("ID")}
                                className={getClassNamesFor("ID")}
                                align="center"
                            >Job ID</TableCell>
                            <TableCell
                                onClick={() => requestSort("Target")}
                                className={getClassNamesFor("Target")}
                                align="center"
                            >Target</TableCell>
                            <TableCell
                                onClick={() => requestSort("Length")}
                                className={getClassNamesFor("Length")}
                                align="center"
                            >Length</TableCell>
                            <TableCell
                                onClick={() => requestSort("Timestamp")}
                                className={getClassNamesFor("Timestamp")}
                                align="center"
                            >Created</TableCell>
                            <TableCell
                                onClick={() => requestSort("Status")}
                                className={getClassNamesFor("Status")}
                                align="center"
                            >Status</TableCell>
                            <TableCell align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            let current_disable = row.Status !== "Finished" ? true : false;
                            // console.log(row.ID,current_disable);
                            return (
                                <TableRow key={row.ID}>
                                    {/* <TableCell align="center"><Button variant="link" disabled={current_disable} value={row.Result} onClick={handleJump}>{row.ID}</Button></TableCell> */}
                                    <TableCell align="center">{row.PK}</TableCell>
                                    <TableCell align="center">{row.Target}</TableCell>
                                    <TableCell align="center">{row.Length}</TableCell>
                                    <TableCell align="center">{new Date(Number(row.Timestamp)).toLocaleString()}</TableCell>
                                    <TableCell align="center">{row.Status !== "Failed" ? row.Status : <Tooltip title={row.Error}><span style={{color:"red"}}>{row.Status}</span></Tooltip>}</TableCell>

                                    <TableCell align="center"><ButtonGroup><Button value={row.Result} variant="outline-success" onClick={handleDownload} disabled={current_disable}>Download</Button></ButtonGroup></TableCell>
                                </TableRow>

                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }


    function handleDownload(e) {
        let current = e.target.value;
        window.open(Bucket + current);
    }

    return (
        <div className="MyAll">
            <>
                <Row className="MyNav">
                    <Col />
                    <Col className="MyContainer1">
                        <NavBar />
                    </Col>
                    <Col />
                </Row>
            </>

            <div style={{ background: "inherited" }}>
                <div style={{ height: "2em" }} />
                <Row style={{ background: "inherited" }}>
                    <Col />
                    <Col className="MyContainer1">
                        <Segment style={{ background: "inherited", opacity: "0.7" }}>
                            <Segment stacked style={{ textAlign: "center" }}>
                                {/* <h1 style={{textAlign:"center"}}>{id}</h1> */}
                                <div style={{ textAlign: "center" }}>
                                    <Row>
                                        <Col />
                                        <Col sm="auto">
                                            <Header as='h1' style={{ color: "#3B75AF" }} >
                                                {/* <Icon name='clipboard list' /> */}
                                                {/* <Header.Content> */}
                                                Results
                                                {/* </Header.Content> */}
                                            </Header>
                                        </Col>
                                        <Col />
                                    </Row>
                                </div>
                            </Segment>

                            {/* <div style={{height:"0.2rem"}} /> */}

                            <Segment >
                                {
                                    isLoaded
                                        ?
                                        <ProjectTable projects={items} />
                                        :
                                        <Segment>
                                            <Dimmer active inverted>
                                                <Loader size='medium'>Loading</Loader>
                                            </Dimmer>

                                            <Image src='../paragraph.png' />
                                        </Segment>
                                }

                                <Row>
                                    <Col md={6}>
                                        <ButtonGroup aria-label="Basic example">
                                            <Button
                                                variant="outline-secondary"
                                                disabled={clicked}
                                                onClick={!clicked ? handleRefresh : null}
                                            >
                                                {
                                                    clicked
                                                        ?
                                                        <Icon loading name='redo' />
                                                        :
                                                        <Icon name='redo' />
                                                }

                                            </Button>
                                            <Button variant="outline-secondary" href="/home">Back</Button>
                                        </ButtonGroup>

                                    </Col>
                                    <Col md={6}>
                                        <TablePagination
                                            component="div"
                                            count={count}
                                            page={page}
                                            onChangePage={handleChangePage}
                                            rowsPerPage={rowsPerPage}
                                            onChangeRowsPerPage={handleChangeRowsPerPage}
                                        />
                                    </Col>
                                </Row>
                            </Segment>
                        </Segment>
                    </Col>
                    <Col />
                </Row>
                <div style={{ height: "2rem" }} />
            </div>


        </div>
    )
}
